import { atom } from "recoil"
export const acceptServiceTermFlagState = atom<boolean>({
  key: "atoms/matching/acceptServiceTermFlagState",
  default: false,
})
